export default __webpack_public_path__ + "static/media/Bids.bcb79351.svg";